import React from 'react';

import {
	Box,
	Stack,
	Input,
	InputGroup,
	InputRightElement,
	Button,
	useColorMode,
	useToast,
} from '@chakra-ui/react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import isElectron from 'is-electron';
// API
import APIFetch from '../../../util/APIFetch';
import ResetAPI from './ForgotAPI';

//Redux
import { connect } from 'react-redux';
import { setUser, setStatus } from '../../../redux/actions';

// Config
import { config } from '../../../config';

//History
import History, { HistoryWithSlug } from '../../../util/History';

//Utils
import KeyEnum from '../../../util/KeyEnum';
//Utils

import validate_email from '../../../util/Validate/validate_email';

// Controllers

const PasswordInput = ({
	name,
	placeholder,
	onChange,
	onKeyDown,
	invalid,
	disabled,
}) => {
	const [show, setShow] = React.useState(false);
	const borderColor = { light: '#f2f2f2', dark: '#494949' };
	const inputBgColor = { light: 'white', dark: '#4c4c4c' };
	const inputFontColor = { light: 'gray.800', dark: 'white' };
	const { colorMode } = useColorMode();
	const handleClick = () => setShow(!show);

	return (
		<InputGroup size="md" fontFamily="body">
			<Input
				name={name}
				type={show ? 'text' : 'password'}
				placeholder={placeholder || 'Enter password'}
				onChange={onChange}
				borderColor={invalid ? 'red.300' : borderColor[colorMode]}
				focusBorderColor={invalid ? 'red.300' : 'purple.500'}
				_placeholder={{ color: inputFontColor[colorMode] }}
				color={inputFontColor[colorMode]}
				fontSize="0.8rem"
				bg={inputBgColor[colorMode]}
				size="md"
				width="14rem"
				borderRadius="5px"
				onKeyDown={onKeyDown}
				isDisabled={disabled}
			/>
			<InputRightElement width="3rem">
				<Box
					as={show ? MdVisibilityOff : MdVisibility}
					size="32px"
					color="gray.300"
					onClick={handleClick}
				/>
			</InputRightElement>
		</InputGroup>
	);
};

const ForgotCard = ({ setUser, setStatus }) => {
	const toast = useToast();
	const [formData, setFormData] = React.useState({});
	const [formAlert, setFormAlert] = React.useState({ type: null });
	const [isSubmitting, setSubmitting] = React.useState(false);
	const [email, setEmail] = React.useState('');
	const [emailErr, setEmailErr] = React.useState(false);
	// Setup the API Fetch utility for the Login View.
	// console.log(formData);
	const [{ fetchResults }] = APIFetch({
		BASEURL: config.fusionAuth.BASEURL,
		PATH_SEARCH: ResetAPI.fusionAuth.forgotPassword.PATH_SEARCH,
		PATH_METHOD: ResetAPI.fusionAuth.forgotPassword.PATH_METHOD,
	});

	//insert reset password logic here
	const handleForgotSubmit = () => {
		let formData = {
			loginId: email,
			sendForgotPasswordEmail: true,
		};
		setSubmitting(true);
		fetchResults(formData)
			.then((res) => {
				console.log(res);
				setSubmitting(false);
				toast({
					title: 'Submitted',
					description: 'Reset link has been sent to your email.',
					status: 'success',
					duration: 3000,
					isClosable: true,
				});
			})
			.catch((err) => {
				console.log(err);
				setSubmitting(false);
				if (err.status === 404) {
					toast({
						title: 'Error',
						description:
							'This email/username is not registered with Maya',
						status: 'error',
						duration: 3000,
						isClosable: true,
					});
				} else {
					toast({
						title: 'Error',
						description:
							'Error initiating a password reset. Contact humans@mayahq.com',
						status: 'error',
						duration: 3000,
						isClosable: true,
					});
				}
			});
	};

	const { colorMode } = useColorMode();

	const fontColor = { light: 'maya_light.400', dark: 'white' };
	const bgColor = { light: '#f9f9f9', dark: '#424242' };
	const borderColor = { light: '#f2f2f2', dark: '#494949' };

	const inputBgColor = { light: 'white', dark: '#4c4c4c' };
	const inputFontColor = { light: 'gray.800', dark: 'white' };

	return (
		<Box
			paddingTop="1rem"
			paddingBottom="2rem"
			paddingX="1.2rem"
			display="flex"
			flexDirection="row"
			justifyContent="center"
			flexGrow="0"
			flexShrink="0"
			bg={bgColor[colorMode]}
			fontFamily="body"
			fontWeight="600"
			borderRadius="5px"
			border="1px solid"
			borderColor={borderColor[colorMode]}
		>
			<Stack>
				<Box color={fontColor[colorMode]} fontSize="1.3rem" mb="1rem">
					Submit Reset Request
				</Box>
				<Box
					width="14rem"
					fontSize="0.7rem"
					fontWeight="400"
					fontFamily="body"
				>
					Enter your registered email ID to get a reset password link.
				</Box>
				<InputGroup size="md" style={{ marginBottom: '0rem' }}>
					<Input
						name="email"
						placeholder="Enter your email"
						onChange={(e) => {
							if (validate_email(e.target.value)) {
								setEmailErr(false);
							} else if (e.target.value) {
								setEmailErr(true);
							} else {
								setEmailErr(false);
							}
							setEmail(e.target.value);
						}}
						_placeholder={{ color: inputFontColor[colorMode] }}
						borderColor={emailErr ? 'red.300' : borderColor[colorMode]}
						focusBorderColor={emailErr ? 'red.300' : 'purple.500'}
						bg={inputBgColor[colorMode]}
						color={inputFontColor[colorMode]}
						size="md"
						width="14rem"
						fontSize="0.8rem"
						colorScheme="purple"
						borderRadius="5px"
					/>
				</InputGroup>

				<Button
					size="md"
					marginTop="0.5rem"
					onClick={handleForgotSubmit}
					isLoading={isSubmitting}
					cursor
					bg={'purple.500'}
					color="white"
					fontSize="0.8rem"
					isDisabled={emailErr || email === ''}
				>
					Submit
				</Button>
			</Stack>
		</Box>
	);
};

// Export the Login View.
export default connect(null, { setUser, setStatus })(ForgotCard);

// <Box
//           display="flex"
//           justifyContent="center"
//           color="gray.600"
//           fontSize="0.8rem"
//           fontFamily="body"
//         >
//           or
//         </Box>
//         <Button leftIcon={FaGoogle} variantColor="gray" size="md">
//           Sign in with Google
//         </Button>
